module.exports = __webpack_public_path__ + "static/media/002_CustomerType@2x.cab7a757.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/optus/002_CustomerType@2x.png
// module id = 564
// module chunks = 0